<template lang="">
  <v-form ref="form" v-bind="this.$attrs" class="mt-4">
    <v-row>
      <v-col cols="6">
        <v-text-field outlined v-model="bankName" label="Ngân hàng" dense></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-text-field
          outlined
          v-model="accountNumber"
          label="Số tài khoản"
          dense
          :rules="[$rules.isNumber]"
          rul
        ></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-text-field outlined v-model="accountHolder" label="Tên tài khoản" dense></v-text-field>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
export default {
  data: () => ({
    bankName: '',
    accountNumber: '',
    accountHolder: ''
  }),
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    getData() {
      return {
        bankName: this.bankName,
        accountNumber: this.accountNumber,
        accountHolder: this.accountHolder ? this.accountHolder.toUpperCase() : ''
      }
    },
    reset() {
      this.$refs.form.reset()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    }
  }
}
</script>
<style lang=""></style>
